import Vue from 'vue'
import axios from 'axios'

import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

import initAxiosInterceptors from './services/api/interceptors'

Vue.config.productionTip = false

// Setup the repository interceptors.
initAxiosInterceptors()

new Vue({
  router,
  axios,
  store,
  vuetify,
  render: function (h) { return h(App) }
}).$mount('#app')
